import * as validation from './validation';

// TODO: Migrate callers to use the validation functions directly
export const required = value => ({
    error: validation.required(value),
});

// TODO: Migrate callers to use the validation functions directly
export const email = value => ({
    error: validation.requiredEmail(value),
});

export const formHasErrors = errors => {
    if (errors) {
        return !!Object.keys(errors).length;
    }
    return false;
};
